import { gql } from "apollo-boost";

const interests = gql`
  {
    interests {
      id
      name
      groupName
    }
  }
`;

const checkInterest = gql`
  query checkInterest($input: SaveInterestInput!) {
    checkInterest(input: $input)
  }
`;

const addInterest = gql`
  mutation addInterest($input: SaveInterestInput!) {
    addInterest(input: $input)
  }
`;

export const interestGql = {
  interests,
  addInterest,
  checkInterest,
};
